import React from 'react';
import { Link } from 'react-router-dom';
import lax from 'lax.js';
import LaxDiv from '../Shared/LaxDiv';
import { HashLink } from 'react-router-hash-link';
import { firstDay, secondDay, thirdDay, fourthDay } from '../helpers/eventagenda'
import { storage } from "../helpers/Firebase";
 
class EventSchedules extends React.Component {

    constructor(props) {
        super(props)
        lax.setup()
    
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY)
        }, false)
    
        lax.update(window.scrollY)
    }
    
    openTabSection = (evt, tabNmae) => {
        let i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabs_item");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }

        tablinks = document.getElementsByTagName("li");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace("current", "");
        }

        document.getElementById(tabNmae).style.display = "block";
        evt.currentTarget.className += "current";
    }

    downloadPdf = () => {
        const ref = storage.ref('/RZI_AGENDA_2024.pdf');
        console.log('ref', ref);
        ref.getDownloadURL().then((url) => {
            // `url` is the download URL for 'images/stars.jpg'
        
            // This can be downloaded directly:
            // const xhr = new XMLHttpRequest();
            // xhr.responseType = 'blob';
            // xhr.onload = (event) => {
            //   const blob = xhr.response;
            // };
            // xhr.open('GET', url);
            // xhr.send();
            window.open(url, '_blank')
          })
          .catch((error) => {
            console.log('error', error);
          });
    }

    

    render(){
        return (
            <section id='agenda' className="schedule-area bg-image ptb-120">
                <div className="container">
                    <div className="section-title">
                        <span>Schedule Plan</span>
                        <h2>Information of <b>Event</b> <br /> Schedules</h2>

                        <LaxDiv text="Agenda" dataPreset="driftLeft" />

                        <HashLink smooth  to="/#register"  className="btn btn-primary">Register Now</HashLink >

                        <div className="bar"></div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="tab">
                                <ul className="tabs active">
                                    <li
                                        onClick={(e) => this.openTabSection(e, 'tab1')}
                                        className="current"
                                    >
                                        <Link to="#">
                                            First Day
                                            <span>21 March 2024</span>
                                        </Link>
                                    </li>

                                    <li onClick={(e) => this.openTabSection(e, 'tab2')}>
                                        <Link to="#">
                                            Second Day
                                            <span>22 March 2024</span>
                                        </Link>
                                    </li>

                                    <li onClick={(e) => this.openTabSection(e, 'tab3')}>
                                        <Link to="#">
                                            Third Day
                                            <span>23 March 2024</span>
                                        </Link>
                                    </li>

                                    <li onClick={(e) => this.openTabSection(e, 'tab4')}>
                                        <Link to="#">
                                            Fourth Day
                                            <span>24 March 2024</span>
                                        </Link> 
                                    </li>
                                </ul>

                                <div className="tab_content">
                                    <div id="tab1" className="tabs_item">
                                        <ul className="accordion">
                                            {firstDay.map((i, index) => 
                                             <li className="accordion-item" key={index}>
                                                <div className="accordion-title">
                                                    <div className="schedule-info">
                                                        <h3>{i.title}</h3>
                                                        <ul>
                                                            <li><i className="icofont-wall-clock"></i>{i.time}</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            )}

                                            {/* <li className="accordion-item">
                                                <Link className="accordion-title" to="#">
                                                     <div className="author author-multi">
                                                        <img 
                                                            src={require("../../assets/images/author6.jpg")}
                                                            data-toggle="tooltip" 
                                                            data-placement="top" 
                                                            title="Steven Lucy" 
                                                            alt="Author"
                                                        />
                                                        <img 
                                                            src={require("../../assets/images/author7.jpg")}
                                                            data-toggle="tooltip" 
                                                            data-placement="top" 
                                                            title="Jonaton Smith" 
                                                            alt="Author"
                                                        />
                                                    </div> 
                                                    
                                                    <div className="schedule-info">
                                                        <h3>Impact of mental health on academics</h3>

                                                        <ul>
                                                            <li><i className="icofont-user-suited"></i> By <span>Robert Downey</span> of USA Inc</li>
                                                            <li><i className="icofont-wall-clock"></i> 13:00AM - 20:00PM</li>
                                                        </ul>
                                                    </div> 
                                                </Link>
                                                
                                                 <div className="accordion-content">
                                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and scrambled it to make Link type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took Link galley of type and scrambled it to make Link type specimen book.</p>

                                                    <div className="row h-100 align-items-center">
                                                        <div className="col-lg-6 col-md-7">
                                                            <div className="location">
                                                                <b>Location:</b> Hall 1, Building C , King Street , <span>USA</span>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6 col-md-5 text-right">
                                                            <Link to="#" className="btn btn-primary">View Details</Link>
                                                        </div>
                                                    </div>
                                                </div> 
                                            </li> */}
                                        </ul>	
                                    </div>

                                    <div id="tab2" className="tabs_item">
                                        <ul className="accordion">
                                            {secondDay.map((i, index) => 
                                             <li className="accordion-item" key={index}>
                                                <div className="accordion-title">
                                                    <div className="schedule-info">
                                                        <h3>{i.title}</h3>
                                                        <ul>
                                                            <li><i className="icofont-wall-clock"></i>{i.time}</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            )}
                                        </ul>	
                                    </div>

                                    <div id="tab3" className="tabs_item">
                                        <ul className="accordion">
                                            {thirdDay.map((i, index) => 
                                             <li className="accordion-item" key={index}>
                                                <div className="accordion-title">
                                                    <div className="schedule-info">
                                                        <h3>{i.title}</h3>
                                                        <ul>
                                                            <li><i className="icofont-wall-clock"></i>{i.time}</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            )}
                                        </ul>	
                                    </div>

                                    <div id="tab4" className="tabs_item">
                                        <ul className="accordion">
                                        {fourthDay.map((i, index) => 
                                             <li className="accordion-item" key={index}>
                                                <div className="accordion-title">
                                                    <div className="schedule-info">
                                                        <h3>{i.title}</h3>
                                                        <ul>
                                                            <li><i className="icofont-wall-clock"></i>{i.time}</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            )}
                                        </ul>	
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="btn-box">
                                <a href="https://firebasestorage.googleapis.com/v0/b/rzi-event.appspot.com/o/RZI_AGENDA_2024.pdf?alt=media" target="_blank" className="btn btn-primary">Download Schedule (PDF)</a>
                                {/* <Link to="#" className="btn btn-secondary">Connect Via Instagram</Link> */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="shape1"><img src={require("../../assets/images/shapes/1.png")} alt="shape1" /></div>
                <div className="shape2 rotateme"><img src={require("../../assets/images/shapes/2.png")} alt="shape2" /></div>
                <div className="shape3 rotateme"><img src={require("../../assets/images/shapes/3.png")} alt="shape3" /></div>
                <div className="shape4"><img src={require("../../assets/images/shapes/4.png")} alt="shape4" /></div>
            </section>
        );
    }
}
 
export default EventSchedules;